import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

// Components
import User from './User';
import UserDetails from './User/UserDetails';
import UserCreate from './User/UserCreate';



// Reducers
import userReducer from './User/store/userReducer';


// const hasPermission = (permissions, permission) => {
//     return permissions.includes('*') || permissions.includes(permission);
// };

// Routes
export const routes = (basePath, permissions) =>
    <Switch>
        {<Route path={basePath} exact component={User} />}
        {<Route path={'/users/details'} component={UserDetails} />}
        {<Route path={'/users/create'} component={UserCreate} />}
    </Switch>


export const reducers = combineReducers({
    users: userReducer
});